<template>
  <div class="slide_container" :class="{ hidden: +index !== +cur_index }" :title="title">
    <div class="slide_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["index", "cur_index", "title"],
};
</script>

<style scoped>
.slide_container {
  flex-grow: 1;
  flex-shrink: 1;

  display: flex;
  flex-direction: column;
  width: 100%;

}

.slide_content {
  flex-grow: 1;

  padding: 5px;
  display: flex;
  flex-direction: column;
}

.hidden {
  display: none;
}
</style>
